<template>
  <div class="main-modal-panels">
    <b-modal
      ok-title="Salvar"
      id="modal-switch-option"
      centered
      size="lg"
      :title= "`${this.$t('panel.createCard.title')}`"
    >
      <div style="text-align: center;">
        <button class="ball-one">1</button>
        <span>{{$t('panel.createCard.choosePanel')}}</span>

        <button class="ball-two">2</button>
        <span>{{$t('panel.createCard.configPanel')}}</span>

        <div class="cards">
          <b-card
            :title="`${$t('panel.createCard.useTemplate')}`"
            :img-src="imgUseTemplate"
            img-alt="Image"
            img-top
            tag="article"
            class="mb-2 p-4 mr-3 ml-3 mb-3"
            id="card-default"
            @click="selectDefault()"
          >
            <b-card-text>
              <p class="description">
                {{$t('panel.createCard.template')}}
              </p>
            </b-card-text>

            <b-button
              href="#"
              variant="primary"
              v-b-modal.modal-default-template
              :disabled="true"
              @click="$bvModal.hide('modal-switch-option')"
              >{{$t('panel.createCard.soon')}}</b-button
            >
          </b-card>

          <b-card
          :title="`${this.$t('panel.createCard.createPanel')}`"
            :img-src="imgMakePanel"
            img-alt="Image"
            img-top
            tag="article"
            id="card-custom"
            class="mb-2 p-4 ml-3 mr-3 mb-3"
            @click="selectCustomPainel()"
          >
            <b-card-text>
              <p class="description">
                {{this.$t('panel.createCard.create')}}
              </p>
            </b-card-text>

            <b-button
              href="#"
              v-b-modal.modal-create-panel
              variant="primary"
              @click="openModalCreatePanel()"
              :disabled="disabledCustom"
              >{{this.$t('panel.createCard.createPanelButton')}}</b-button
            >
          </b-card>
        </div>
      </div>
    </b-modal>

    <modalAddTemplateDefault />

    <b-modal
      ok-title="Salvar"
      id="modal-create-panel"
      centered
      :title="`${this.$t('panel.createCardSecondStep.createPanel')}`"
      v-b-toggle.sidebar-right
      @ok="openCreateCard()"
      size="lg"
      v-model="modalPanel"
    >
      <div style="text-align: center;">
        <button class="ball-create-panel">1</button>
        <span>{{$t('panel.createCard.choosePanel')}}</span>

        <button class="ball-create-panel">2</button>
        <span>{{$t('panel.createCard.configPanel')}}</span>
      </div>

      <div>
        <p class="text-create-panel">{{$t('panel.createCardSecondStep.panelTitle')}}</p>
        <input class="form-control" v-model="title" />

        <p class="text-create-panel">{{$t('panel.createCardSecondStep.description')}}</p>
        <textarea class="form-control" v-model="description" />

        <template v-if="userProfile.permissions.panels.share_panel">
          <p class="text-create-panel">{{$t('panel.createCardSecondStep.accessPermission')}}</p>
          <b-form-checkbox-group
            v-model="perfils"
            :options="profiles"
            class="mb-3"
          ></b-form-checkbox-group>
        </template>
      </div>

      <template #modal-footer>
        <b-button variant="outline-primary" @click="cancel()">
          {{$t('panel.createCardSecondStep.cancel')}}
        </b-button>
        <b-button variant="primary" @click="savePanel()"> {{$t('panel.createCardSecondStep.save')}}</b-button>
      </template>
    </b-modal>

    <template>
      <div>
        <b-sidebar
          v-model="showSidebar"
          id="sidebar-right"
          title="Sidebar"
          width="550px"
          no-header
          style="background: #fff;"
          right
          shadow
        >
          <template>
            <createCard :idPanel="idPanel" />
          </template>
        </b-sidebar>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import createCard from '../../molecules/add-card';
import imgUseTemplate from '../../../assets/use-template.jpg';
import imgMakePanel from '../../../assets/make-panel.jpg';
import api from '../../../services/api';
import modalAddTemplateDefault from '../modal-add-template';

export default {
  name: 'ModalAddPanels',
  components: {
    modalAddTemplateDefault,
    createCard,
  },
  computed: {
    ...mapFields('panels', ['panelsInfo', 'showSidebar', 'idPanel']),
    ...mapFields('profiles', ['profiles']),
    ...mapFields('actions', ['allGroups']),
    ...mapState('actions', ['allActions']),
    ...mapState('branches', ['ih1', 'ih2']),
    ...mapState('authentication', ['userProfile']),
  },
  data: () => ({
    disabledCustom: true,
    disabledDefault: true,
    modalPanel: null,
    imgUseTemplate,
    imgMakePanel,
    optionsReports: [],
    optionsAnalysis: [],
    selectedReport: null,
    selectedAnalysis: null,
    selectedPeriod: null,
    slide: 0,
    sliding: null,
    title: '',
    description: '',
    perfils: [],
    userAuth: null,
    allAnalysesTypes: null,
    filterGroup: null,
    optionsGroup: [],
    groupAction: null,
    action: null,
    branch: null,
    indicators: null,
    valuesIndicator: [],
    indicator: null,
    valueIndicator: null,
    metric: null,
    optionsMetrics: [
      {
        value: null,
        text: 'Selecione a métrica',
      },
      {
        value: 'nps-0-10',
        text: 'NPS - escala 0 a 10',
      },
      {
        value: 'nps-1-5',
        text: 'NPS - escala 1 a 5',
      },
      {
        value: 'ces-1-5',
        text: 'CES - escala 1 a 5',
      },
      {
        value: 'csat-1-5',
        text: 'CSAT - escala 1 a 5(Top 2 box)',
      },
      {
        value: 'csat-1-5(media)',
        text: 'CSAT - escala 1 a 5(media)',
      },
      {
        value: '5-stars',
        text: '5-Stars',
      },
      {
        value: 'like-dislike',
        text: 'Like/Dislike 0 e 1',
      },
    ],
    limit: 20,
    limitValue: 20,
    indicatorsFilterValue: [],
    actionFilter: null,
    indicatorFilter: null,
    actionGroupFilter: null,
    branchFilter: null,
    indicatorValueFilter: null,
    graph: null,
    // idPanel: null,
  }),
  methods: {
    ...mapActions('profiles', ['getProfiles']),
    ...mapActions('panels', [
      'setPanelsInfo',
      'setShowSidebar',
      'setCreatePanel',
      'getAllPanels',
    ]),
    replaceQueryParams(object) {
      this.$router.replace({
        path: this.$route.path,
        query: { ...this.$route.query, ...object },
      });
    },
    cancel() {
      this.modalPanel = false;
    },
    removeFilter(value) {
      if (value === 'indicator') {
        this.indicatorValue = null;
        this.indicator = null;
      } else if (value === 'branch') {
        this.branch = null;
      } else if (value === 'action') {
        this.action = null;
      } else if (value === 'groupAction') {
        this.groupAction = null;
      }
    },
    handleIndicatorData(item) {
      this.valueIndicator = item;
    },
    loadMoreIndicValue() {
      this.limitValue = this.limitValue + 20;
    },
    getIndicatorsValuePaginate() {
      let indicators;
      if (this.indicatorsFilterValue) {
        if (this.limitValue >= this.indicatorsFilterValue.length) {
          document.querySelector('#loadmore-indic-value').style.display =
            'none';
        } else {
          document.querySelector('#loadmore-indic-value').style.display =
            'block';
        }
        indicators = this.indicatorsFilterValue.slice(0, this.limitValue);
        if (indicators.length < 19) {
          document.querySelector('#loadmore-indic-value').style.display =
            'none';
        }
      }
      return indicators;
    },
    checkIndicatorData() {
      if (this.indicator) {
        return this.$t('menu.filter.indicators', {
          indicatorData: `${this.indicator.name}`,
        });
      }
      return this.$t('menu.filter.indicatorData');
    },
    isDateIndicator(value) {
      if (this.indicators) {
        for (let i = 0; i < this.indicators.length; i += 1) {
          if (this.indicators[i]._id === value) {
            return true;
          }
        }
      }
      return false;
    },
    async setIndicator(indicator) {
      this.indicator = indicator;
      const response = await api.get(
        `/filters/indicator-data/${this.userAuth.companyId}`,
        {
          headers: { 'x-access-token': this.userAuth.token },
          params: {
            indicatorValue: indicator.key,
            groupId: null,
            actionId: null,
            ih1: null,
          },
        },
      );
      this.allIndicatorData = response.data;
      this.indicatorsFilterValue = response.data;
    },
    loadMore() {
      this.limit = this.limit + 20;
    },
    getIndicatorsPaginate() {
      let indicators;
      if (this.indicators) {
        if (this.limit >= this.indicators.length) {
          document.querySelector('#loadmore').style.display = 'none';
        } else {
          document.querySelector('#loadmore').style.display = 'block';
        }
        indicators = this.indicators.slice(0, this.limit);
        if (indicators.length < 19) {
          document.querySelector('#loadmore').style.display = 'none';
        }
      }
      return indicators;
    },
    setValBranch(branch) {
      this.branch = branch;
    },
    setValAction(action) {
      this.action = action;
    },
    setActionGroup(group) {
      this.groupAction = group;
    },
    setAnalysysis(value) {
      this.selectedAnalysis = value;
    },
    onSlideStart() {
      if (this.slide !== this.slide.length - 1) {
        this.slide = this.slide + 1;
      }
    },
    onSlideEnd() {
      if (this.slide !== 0) {
        this.slide = this.slide - 1;
      }
    },
    async savePanel() {
      this.modalPanel = false;
      const panelsInfo = {
        title: this.title,
        description: this.description,
        perfils: this.perfils,
      };
      const dataPanel = await this.setCreatePanel({
        token: this.userAuth.token,
        panelsInfo,
      });
      this.idPanel = dataPanel._id;
      this.replaceQueryParams({
        idpanel: dataPanel._id,
      });
      await this.getAllPanels({
        token: this.userAuth.token,
      });
      this.setShowSidebar(true);
    },
    async getDataPanel() {
      if (this.idPanel) {
        const response = await api.get(`/get/panel/${this.idPanel}`, {
          headers: { 'x-access-token': this.userAuth.token },
          params: {
            idPanel: this.idPanel,
          },
        });
        this.panel = response.data;
      }
    },
    openCreateCard() {
      this.$bvModal.hide('modal-create-panel');
    },
    openModalCreatePanel() {
      this.$bvModal.hide('modal-switch-option');
    },
    selectDefault() {
      this.disabledCustom = true;
      this.disabledDefault = false;
      document.getElementById('card-custom').style.background = '#f8f9fa';
      document.getElementById('card-default').style.background = '#fff';
    },
    selectCustomPainel() {
      this.disabledCustom = false;
      this.disabledDefault = true;
      document.getElementById('card-custom').style.background = '#fff';
      document.getElementById('card-default').style.background = '#f8f9fa';
    },
    async getTypeAnalysis() {
      const response = await api.get('get/analysis', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
      });
      this.allAnalysesTypes = response.data;
      response.data.forEach((el) => {
        this.optionsAnalysis.push({
          value: el.analysisType,
          text: el.analysisType,
        });
      });
    },
    async handleIndicator() {
      const response = await api.get(
        `/filters/indicators/${this.userAuth.companyId}`,
        {
          headers: { 'x-access-token': this.userAuth.token },
        },
      );
      this.indicators = response.data.indicators;
    },
  },
  watch: {
    metric: function watchMetric(metric) {
      this.optionsAnalysis = [];
      this.selectedAnalysis = null;
      this.selectedReport = null;
      const array = [];
      for (let i = 0; i < this.allAnalysesTypes.length; i += 1) {
        if (
          this.allAnalysesTypes[i].metric.indexOf(metric.substr(0, 3)) !== -1
        ) {
          array.push(this.allAnalysesTypes[i]);
        }
      }
      array.forEach((el) => {
        this.optionsAnalysis.push({
          value: el.analysisType,
          text: el.analysisType,
        });
      });
    },
    selectedAnalysis: function watchSelectedAnalysis(value) {
      for (let i = 0; i < this.allAnalysesTypes.length; i += 1) {
        if (value === this.allAnalysesTypes[i].analysisType) {
          this.optionsReports = this.allAnalysesTypes[i].reports;
        }
      }
    },
    indicator: async function watchValueIndicator(value) {
      const response = await api.get(
        `/filters/indicator-data/${this.userAuth.companyId}`,
        {
          headers: { 'x-access-token': this.userAuth.token },
          params: {
            indicatorValue: value.key,
          },
        },
      );
      this.valuesIndicator = response.data;
    },
  },
  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    if (this.panelsInfo.length > 0) {
      this.replaceQueryParams({
        idpanel: this.panelsInfo[0]._id,
      });
      this.idPanel = this.panelsInfo[0]._id;
    }
    this.getTypeAnalysis();
    this.handleIndicator();
    this.optionsGroup = [
      { value: null, text: 'Escolha o filtro' },
      { value: 'Grupo de ações', text: 'Grupo de ações' },
      { value: 'Ação', text: 'Ação' },
      { value: 'Indicador', text: 'Indicador' },
      { value: 'Filial', text: 'Filial' },
    ];
    await this.getProfiles({
      token: this.userAuth.token,
      companyId: this.userAuth.companyId,
    });
  },
};
</script>

<style>
/* .dropdown-toggle-no-caret {
  color: #606060 !important;
  border-color: #ced4da !important;
  font-size: 1rem !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  border-radius: 0 !important;
} */
</style>

<style scoped>
.btn-loadmore {
  border: none;
  padding: 10px 20px;
  font-size: 18px;
  cursor: pointer;
  color: #4ce595;
  border-radius: 4px;
  background-color: #fff;
}
.button--formater2 {
  float: left;
}
.button--formater {
  float: left;
}
.tag {
  background: #4ce595;
  padding: 4px 8px;
  color: #fff;
  border-radius: 8px;
  margin-right: 8px;
  min-width: 30%;
  max-width: 80%;
  margin-top: 10px;
}
.remove {
  cursor: pointer;
}
.ball-one {
  border-radius: 50%;
  display: inline-table;
  height: 25px;
  color: #fff;
  width: 25px;
  font-size: 14px;
  border: 1px solid #3db374;
  background-color: #3db374;
}
.ball-two {
  border-radius: 50%;
  display: inline-table;
  height: 25px;
  color: #fff;
  width: 25px;
  font-size: 14px;
  border: 1px solid #bdbdbd;
  background-color: #bdbdbd;
}
.cards {
  align-items: center;
  justify-content: center;
  display: flex;
  padding-top: 25px;
}
.title-card {
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
}
.description {
  font-weight: 400;
  font-size: 12px;
  color: #242424;
}
#card-default {
  max-width: 80rem;
  width: 80rem;
  height: 30rem;
}
#card-custom {
  max-width: 80rem;
  width: 80rem;
  background-color: #f8f9fa;
  height: 30rem;
}
.card-img-top {
  padding-top: 40px;
  padding-right: 40px;
  padding-left: 40px;
}
.ball-create-panel {
  border-radius: 50%;
  display: inline-table;
  height: 25px;
  color: #fff;
  width: 25px;
  font-size: 14px;
  border: 1px solid #3db374;
  background-color: #3db374;
}
.text-create-panel {
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  margin-left: 5px;
  margin-right: 5px;
  margin-bottom: 5px;
  margin-top: 20px;
}
.b-sidebar-outer {
  z-index: 1040;
}
.create-card {
  font-weight: 700;
  font-size: 26px;
  line-height: 28px;
}
.card-description {
  font-weight: 400;
  font-size: 16px;
  line-height: 18px;
}
.main-sidebar {
  padding-left: 50px;
  padding-right: 50px;
  padding-top: 12px;
  background: #fff;
}
.label-text {
  margin-bottom: 0;
  margin-top: 15px;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/modal-add-panel/index.vue